<template>
  <div 
    class="glass-card" 
    :class="[sizeClass, { 'glass-card--hoverable': hoverable, 'glass-card--clickable': clickable }]"
    @click="handleClick"
  >
    <div v-if="$slots.header" class="glass-card__header">
      <slot name="header"></slot>
    </div>
    <div class="glass-card__body" :class="{ 'glass-card__body--no-padding': noPadding }">
      <slot></slot>
    </div>
    <div v-if="$slots.footer" class="glass-card__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlassCard',
  emits: ['click'],
  props: {
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg', 'xl', 'full'].includes(value)
    },
    hoverable: {
      type: Boolean,
      default: true
    },
    clickable: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sizeClass() {
      return `glass-card--${this.size}`;
    }
  },
  methods: {
    handleClick(event) {
      if (this.clickable) {
        this.$emit('click', event);
      }
    }
  }
};
</script>

<style scoped>
.glass-card {
  background: transparent;
  backdrop-filter: blur(var(--glass-blur));
  -webkit-backdrop-filter: blur(var(--glass-blur));
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 24px;
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.4),
    inset 0 -1px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  overflow: hidden;
}

.glass-card--hoverable:hover {
  transform: translateY(-2px);
  box-shadow: 
    0 12px 40px rgba(0, 0, 0, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.5),
    inset 0 -1px 0 rgba(0, 0, 0, 0.05);
}

.glass-card--clickable {
  cursor: pointer;
}

/* Sizes */
.glass-card--sm {
  max-width: 400px;
}

.glass-card--md {
  max-width: 600px;
}

.glass-card--lg {
  max-width: 800px;
}

.glass-card--xl {
  max-width: 1000px;
}

.glass-card--full {
  max-width: 100%;
}

/* Header */
.glass-card__header {
  padding: 1.5rem 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.05);
}

/* Body */
.glass-card__body {
  padding: 2rem;
}

.glass-card__body--no-padding {
  padding: 0;
}

/* Footer */
.glass-card__footer {
  padding: 1.5rem 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.05);
}

/* Responsive */
@media (max-width: 768px) {
  .glass-card {
    border-radius: 16px;
  }
  
  .glass-card__header,
  .glass-card__body,
  .glass-card__footer {
    padding: 1rem 1.25rem;
  }
}
</style>
